"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constant = void 0;
var Constant;
(function (Constant) {
    let user;
    (function (user) {
        user["EMAIL"] = "email";
        user["PHONE"] = "phone";
        user["IDP_ID"] = "idp_id";
    })(user = Constant.user || (Constant.user = {}));
    let treeType;
    (function (treeType) {
        treeType["DRAFT"] = "draft";
        treeType["LIVE"] = "live";
        treeType["VERSION"] = "version";
    })(treeType = Constant.treeType || (Constant.treeType = {}));
    Constant.REDIS_CONFIG = "RedisConfig";
    Constant.IDP_CONFIG = "IdpConfig";
    Constant.INDETERMINATE = "indeterminate";
    let ValueBy;
    (function (ValueBy) {
        ValueBy["FALLBACK"] = "fallback";
        ValueBy["EXPLICIT"] = "explicit";
        ValueBy["DEFAULT"] = "default";
        ValueBy["INHERITANCE"] = "inheritance";
        ValueBy["READONLY"] = "readonly";
    })(ValueBy = Constant.ValueBy || (Constant.ValueBy = {}));
    Constant.ERROR_PREFERENCE_IS_READONLY = "PreferenceIsReadonly";
    Constant.SENDGRID = "Sendgrid";
    Constant.SALESFORCE = "SalesForce";
    let IdpUserEventTypes;
    (function (IdpUserEventTypes) {
        IdpUserEventTypes["CREATED"] = "vacasa.platform.data.users.create";
        IdpUserEventTypes["UPDATED"] = "vacasa.platform.data.users.update";
    })(IdpUserEventTypes = Constant.IdpUserEventTypes || (Constant.IdpUserEventTypes = {}));
})(Constant = exports.Constant || (exports.Constant = {}));
//# sourceMappingURL=constants.js.map